import { Component, OnInit } from "@angular/core";
import { Ikr998ErtUsers } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { TrainingType } from "../../../services/administration/trainingtypes/trainingtypes";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Kr998ErtUsersService } from "../../../services/kr998ErtUsers/kr998ErtUsers.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AttendanceStatus } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998-attendancestatus";
import { AttendanceType } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998-attendanceType";
import { IFacilityData } from "../../../interfaces/administration/facilityData";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-ert-kr998ertusers-details",
  templateUrl: "./ert-kr998-ertusers-details.component.html",
  styleUrl: "",
})
export class ErtKr998ertusersDetailsComponent implements OnInit {
  krForm: FormGroup;
  id: number;
  data: Ikr998ErtUsers;
  facilities: IFacilityData[];
  formErrors: string[] = [];
  trainingTypes = TrainingType;
  attendanceTypes = AttendanceType;
  attendanceStatus = AttendanceStatus;
  isKr998Loading = false;

  facilityId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private k998ErtUsersService: Kr998ErtUsersService,
    private loggedUserService: LoggedUserService
  ) {
    this.krForm = this.fb.group({
      kr998DetailsId: [{ value: "", disabled: true }],
      attendanceType: [""],
      userErtId: [{ value: "", disabled: true }],
      cai: [{ value: "", disabled: true }],
      Kr998Id: [{ value: "", disabled: true }],
      attendanceStatus: [""],
      memberName: [{ value: "", disabled: true }],
      hours: [0],
      trainingTypes: [{ value: "", disabled: true }],
      isInstructior: [false],
      instructorAtTimeOfClass: [false],
    });
    this.data = {
      hours: 0,
    } as Ikr998ErtUsers;
  }

  ngOnInit(): void {
    this.isKr998Loading = true;
    this.id = +this.route.snapshot.paramMap.get("id")!;
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.facilityId = Number(user?.facilityId) || 0;
      this.k998ErtUsersService.getByKr998Id(this.id, this.facilityId).subscribe((data) => {
        if (
          data.userErt?.facilityId !== this.facilityId ||
          data.kr998?.facilityId !== this.facilityId
        ) {
          this.router.navigate(["/no-access"]);
          return;
        }
        setTimeout(() => {
          this.data = data;
          this.initializeRecord();
        }, 10);
        this.isKr998Loading = false;
      });
    });
  }

  initializeRecord(): void {
    if (this.data.hours === 0) {
      this.data.hours = this.data.kr998.hours;
    }
    const attendanceTypeValue = this.data.attendanceType
      ? this.data.attendanceType
      : AttendanceType.ERT;
    this.krForm.patchValue({
      kr998DetailsId: this.data.kr998DetailsId,
      attendanceType: attendanceTypeValue,
      userErtId: this.data.userErtId,
      cai: this.data.userErt.caiEmail,
      Kr998Id: this.data.kr998Id,
      attendanceStatus: this.data.attendanceStatus,
      memberName: this.data.userErt.fullName,
      hours: this.data.hours,
      trainingTypes: this.getTrainingTypeName(this.data.kr998.trainingType),
      isInstructior: this.data.isInstructior,
      instructorAtTimeOfClass: this.data.instructorAtTimeOfClass,
    });
    this.krForm.get("hours")?.valueChanges.subscribe((value) => {
      this.data.hours = value;
    });
    this.krForm.get("attendanceStatus")?.valueChanges.subscribe((value) => {
      this.data.attendanceStatus = value;
    });
  }

  onIsInstructorChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.krForm.patchValue({
      isInstructior: checked,
    });
  }

  onInstructorAtTimeOfClassChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.krForm.patchValue({
      instructorAtTimeOfClass: checked,
    });
  }

  onSubmit(): void {
    this.formErrors = this.k998ErtUsersService.validate(this.krForm);
    if (this.formErrors.length === 0) {
      const updatedData: Ikr998ErtUsers = {
        ...this.krForm.getRawValue(),
        kr998DetailsId: this.data.kr998DetailsId,
        userErtId: this.data.userErtId,
        isInstructior: this.krForm.value.isInstructior,
        instructorAtTimeOfClass: this.krForm.value.instructorAtTimeOfClass,
        userErt: this.data.userErt,
        kr998: this.data.kr998,
      };
      this.k998ErtUsersService.updateERTUser(updatedData, this.facilityId).subscribe(() => {
        this.router.navigate(["/ert-kr998/ert-kr998-view", this.data.kr998Id]);
      });
    }
  }

  getTrainingTypeName(trainingTypeId: number): string {
    return TrainingType[trainingTypeId];
  }

  getAttendanceStatusName(attendanceStatusId: number): string {
    return AttendanceStatus[attendanceStatusId];
  }
  getAttendanceTypeKeys(): string[] {
    return Object.keys(this.attendanceTypes).filter(
      (key) => !isNaN(Number(this.attendanceTypes[key]))
    );
  }
  getAttendanceStatusKeys(): string[] {
    return Object.keys(this.attendanceStatus).filter(
      (key) => !isNaN(Number(this.attendanceStatus[key]))
    );
  }

  onCancel(): void {
    this.router.navigate(["/ert-kr998/ert-kr998-view", this.data.kr998Id]);
  }
}
